import * as React from "react";

interface Props {
  value: number;
  symbol?: string;
  decimalsClassName?: string;
  decimalSeparator?: string;
}

export default function Money({ value, symbol = "$", decimalsClassName, decimalSeparator }: Props) {
  const [base, decimals] = splitNumber(value);
  const separator = decimalSeparator || DECIMAL_SEPARATOR;

  return (
    <React.Fragment>
      {symbol}
      {base}
      {separator}
      <small className={decimalsClassName}>{decimals}</small>
    </React.Fragment>
  );
}

export function InvoiceItem({ value, symbol = "$", decimalsClassName, decimalSeparator }: Props) {
  if (value < 0) {
    return (
      <React.Fragment>
        (<Money value={value * -1} symbol={symbol} decimalsClassName={decimalsClassName} decimalSeparator={decimalSeparator} />)
      </React.Fragment>
    );
  }
  return <Money value={value} symbol={symbol} decimalsClassName={decimalsClassName} decimalSeparator={decimalSeparator} />;
}

export const DECIMAL_SEPARATOR = (/^1(.+)1$/.exec((1.1).toLocaleString()) || ["."])[1];

export function splitNumber(num: number) {
  return (num || 0)
    .toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })
    .split(DECIMAL_SEPARATOR);
}
